import type { EventDetails } from "@/modules/eventDetails/client/api/types"
import type { FunctionComponent } from "react"

import { LocationOutlined } from "@jobteaser/spark/components/Icons/LocationOutlined"
import { Video } from "@jobteaser/spark/components/Icons/Video"
import { Text } from "@jobteaser/spark/components/Text"

import { ADDRESS, CAMPUS, ONLINE } from "@/modules/eventDetails/client/constants"
import { useEventDetailsData } from "@/modules/eventDetails/client/hooks/useEventDetailsData"
import { getTranslationFromLocale } from "@/modules/eventDetails/client/utils/translationHelper"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useLocale } from "@/modules/locales/useLocale"

import styles from "./MainDetails.module.css"

export const Location: FunctionComponent = () => {
  const event = useEventDetailsData()
  const { t } = useTranslation(["event_details"])
  const locale = useLocale()
  const { location } = event as EventDetails

  if (location.type === ONLINE) {
    return (
      <div className={styles.flexContainer} data-testid="event-details-main-details-location-online">
        <Video className={styles.icon} />
        <Text variant="body1" weight="bold">
          {t("event_details.location.online")}
        </Text>
      </div>
    )
  }

  let locationValue = ""

  if (location.type === CAMPUS) {
    locationValue = getTranslationFromLocale(location.name, locale)
  }
  if (location.type === ADDRESS) {
    locationValue = location.details
  }

  return (
    <div className={styles.flexContainer} data-testid="event-details-main-details-location-in-person">
      <LocationOutlined className={styles.icon} />
      <address className={styles.location} data-testid="event-details-main-details-location-address">
        <Text
          as="span"
          variant="body1"
          weight="bold"
          data-testid={`event-details-main-details-location-${locationValue}`}
        >
          {locationValue}
        </Text>
        {location.room && (
          <Text
            as="span"
            variant="body1"
            className={styles.dashSeparator}
            data-testid="event-details-main-details-location-room"
          >
            {location.room}
          </Text>
        )}
      </address>
    </div>
  )
}
